<template>
  <div class="page-redirect">
  </div>
</template>

<script type="text/javascript">
export default{
  data () {
    return {
      mixindisabled: true
    }
  },
  mounted () {
    let that = this
    let _obj = this.getRequest()
    if (!_obj.token) {
      that.$router.push({path: '/login'})
    } else {
      that.setSession('account', _obj.account || '')
      that.setSession('token', _obj.token || '')
      that.$router.replace({path: '/index'})
    }
  }
}
</script>

<style type="text/css" lang="scss" scoped>
.page-login{
  width: 100%;
  height: 100%;
  background: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/pages/Redirect.vue